import styles from './review_summary.module.scss';
import {classNames} from '../../../support/classnames.ts';
import {Button} from '../../../components/button/button.tsx';
import {__} from '../../../support/lang/translations.ts';

interface OwnProps {
    average12MonthsRating?: number | null;
    averageRating?: number | null;
    numberOfReviews?: number | null;
    numberOfReviews12Months?: number | null;
    percentageRecommended?: number | null;
    reviewUrl?: string | null;
}

export function ReviewSummary({
    average12MonthsRating,
    averageRating,
    numberOfReviews,
    numberOfReviews12Months,
    percentageRecommended,
    reviewUrl,
}: OwnProps) {
    return (
        <div className={styles.review_summary}>
            <div className={styles.summary_graphic}>
                <span className={styles.graphic_value}>{averageRating}</span>
                <span className={styles.graphic_label}>{numberOfReviews} reviews</span>
            </div>
            <div className={styles.summary_column}>
                <div className={styles.summary_info}>
                    <span>{__('reviews.average_12_months_rating')}</span>
                    <strong>{average12MonthsRating}</strong>
                </div>
                <div className={styles.summary_info}>
                    <span>{__('reviews.percentage_recommended')}</span>
                    <strong>{percentageRecommended}%</strong>
                </div>
                <div className={styles.summary_info}>
                    <span>{__('reviews.number_of_reviews_12_months')}</span>
                    <strong>{numberOfReviews12Months}</strong>
                </div>
            </div>
            <div className={styles.summary_column}>
                <div className={styles.summary_info}>
                    <div className={styles.bar}>
                        <span
                            className={classNames(
                                styles.bar_value,
                                `bar_value_${Math.ceil(average12MonthsRating ?? 0)}`,
                            )}
                        />
                    </div>
                </div>
                <div className={styles.summary_info}>
                    <div className={styles.bar}>
                        <span
                            className={classNames(
                                styles.bar_value,
                                `bar_value_${Math.ceil((percentageRecommended ?? 1) / 10 ?? 0)}`,
                            )}
                        />
                    </div>
                </div>
                <div className={styles.summary_info}>
                    {reviewUrl != null && (
                        <Button to={reviewUrl} target={'_blank'}>
                            <i className="fa-light fa-external-link" />
                            {__('reviews.buttons.create')}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}
